import { ActionType as ActionTypeEnum } from '../../types';
import { mapTransformations } from './transformations';
import { handleFileSource, handleUrlSource } from './upload/upload-handlers';
import { codeToBase64, removePrefix } from './utils';
export function makeDhProvider({ url }) {
    const prefixRegex = new RegExp(`^dh:`);
    return {
        name: 'dh',
        getImageUrl({ source, transformations }) {
            const cleanSource = removePrefix(source, prefixRegex);
            const dhTransformantions = mapTransformations(transformations);
            const codedTransformations = codeToBase64(dhTransformantions);
            return [url, cleanSource]
                .filter((e) => e)
                .join('/')
                .concat(codedTransformations);
        },
        uploadImage(source, options) {
            if (source instanceof File || source instanceof Blob) {
                return handleFileSource(source, options);
            }
            else {
                return handleUrlSource(source, options);
            }
        },
        canHandle(actionType, source) {
            // We need to keep the dh: prefix for images so multimedia can also work with other custom providers that other web-apps might add.
            if (actionType === ActionTypeEnum.GetImage)
                return prefixRegex.test(source);
            if (actionType === ActionTypeEnum.UploadImage)
                return true;
            return false;
        },
    };
}
//# sourceMappingURL=dh.js.map